exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container--2MtQp {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -moz-box;\r\n    display: flex;\r\n}\r\n\r\n    .container--2MtQp .preview--1ddsN {\r\n        -webkit-box-flex: 500px;\r\n        -webkit-flex: 500px 0;\r\n           -moz-box-flex: 500px;\r\n                flex: 500px 0;\r\n    }\r\n\r\n    .container--2MtQp .form--346nu {\r\n        -webkit-box-flex: 476px;\r\n        -webkit-flex: 476px 0;\r\n           -moz-box-flex: 476px;\r\n                flex: 476px 0;\r\n        margin-left: 24px;\r\n    }\r\n", ""]);

// Exports
exports.locals = {
	"container": "container--2MtQp",
	"preview": "preview--1ddsN",
	"form": "form--346nu"
};